<div class="modal-body">
  <div class="content">
    <div class="content__main">
      <div class="top">
        <h4 translate>company.user.add-popup.title</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <i class="icon-small-close" aria-hidden="true"></i>
        </button>
      </div>
      <gdp-add-edit-user-form (onSubmit)="addUser($event)" [loading]="loading" [user]="user"></gdp-add-edit-user-form>
    </div>
  </div>
</div>
